import { Checkbox, FormControlLabel, styled } from '@mui/material';

export const CheckboxBlock = styled(Checkbox)(({ theme }) => ({
    padding: 0,
    background: 'none',
    border: 'none',
    borderRadius: '5px',
    color: theme.custom.c47,
    '.MuiSvgIcon-root': {
        fontSize: '1.125rem',
    },
    '& + .MuiFormControlLabel-label': {
        color: theme.custom.c47,
    },
    '&.Mui-checked': {
        borderRadius: '5px',
        background: theme.palette.secondary.main,
        color: theme.custom.c1,
        '& + .MuiFormControlLabel-label': {
            color: theme.palette.secondary.main,
        },
    },
    '&.Mui-disabled': {
        color: theme.custom.c45,
        '& + .MuiFormControlLabel-label': {
            color: theme.custom.c45,
        },
        '&.Mui-checked': {
            color: theme.custom.c45,
            background: theme.custom.c47,
        },
    },
}));

export const CheckboxWrap = styled(FormControlLabel)(({ theme }) => ({
    margin: 0,
    gap: '8px',
    userSelect: 'none',
    '.MuiFormControlLabel-label': {
        lineHeight: '1.25',
    },
    '&:hover': {
        '&:not(.Mui-disabled)': {
            '.MuiCheckbox-root': {
                '&:not(.Mui-checked)': {
                    color: theme.palette.secondary.main,
                    '& + .MuiFormControlLabel-label': {
                        color: theme.palette.secondary.main,
                    },
                },
            },
        },
    },
}));
